import { createAction } from 'redux-actions';
import uuid from 'uuid/v4';
import {
  createParams,
  validateParams,
  getValueFromObjects,
  getCPRMapping,
  getAddressMappingV2,
  getCustomerAge,
  prepareCommonCreateUpdateResponse,
} from './common';
import Product from './product';
import * as types from '../../constants/personal-api';
import { createErrorBody } from '../error';

class PersonalService extends Product {
  static TYPE = 'personal';
  static GET_PRICE = 'person/v1/price';
  static UPDATE_PRICE = 'person/v1/price';
  static CREATE_CUSTOMER = 'product/v1/customer';
  static PERSONAL_PURCHASE = 'person/v1/purchase';
  static createdPersonal = createAction(types.PERSONAL_CREATED);
  static createPersonal = createAction(types.PERSONAL_CREATE);
  static updatedPersonal = createAction(types.PERSONAL_UPDATED);
  constructor() {
    super(
      PersonalService.TYPE,
      PersonalService.createPersonal
    );
    super.prepareCreateUpdateResponse = this.prepareCreateUpdateResponse;
  }

  createdPersonalAction(payload) {
    return (dispatch) => dispatch(PersonalService.createdPersonal(payload));
  }

  createPersonalAction(mappedParams, actionOnErrors, requestModel, formValues) {
    return (dispatch, getState) => {
      return dispatch(
        this.requestCreateProductV2(
          PersonalService.GET_PRICE,
          mappedParams,
          requestModel,
          formValues
        )
      )
        .then((data) => {
          dispatch(this.createdPersonalAction(data));
        })
        .catch((data) => {
          return this.handleError(actionOnErrors, data, getState, dispatch);
        });
    };
  }

  updatedPersonalAction(payload) {
    return (dispatch) => dispatch(PersonalService.updatedPersonal(payload));
  }

  updatePersonalAction(mappedParams, actionOnErrors, reqModel, formValues) {
    return (dispatch, getState) => {
      return dispatch(
        this.requestCreateProductV2(
          PersonalService.UPDATE_PRICE,
          mappedParams,
          reqModel,
          formValues
        )
      )
        .then((data) => {
          dispatch(this.updatedPersonalAction(data));
        })
        .catch((data) => {
          return this.handleError(actionOnErrors, data, getState, dispatch);
        });
    };
  }

  createUpdatePersonalAction(params, actionOnErrors, values) {
    return (dispatch, getState) => {
      const state = getState();
      const formValues = { ...values, ...state.userData };
      const mappedParams = params
        ? createParams(params, formValues, state)
        : {};
      const errors = params ? validateParams(mappedParams, params) : [];

      if (errors.length > 0) {
        return Promise.reject(createErrorBody('Missing parameters', errors));
      }
      const age = getCustomerAge(mappedParams, formValues);
      let ageGroup = 'Senior';
      if (age >= 18 && age <= 24) {
        ageGroup = 'Ung';
      } else if (age > 24 && age <= 69) {
        ageGroup = 'Voksen';
      }

      const requestModel = {
        general: {
          globalTransactionId: uuid(),
          trygConcept: '',
          campaignCode: '',
        },
        generalInsurance: {
          productGroupName: 'Person',
        },
        trygDrive:
          getValueFromObjects('trygDrive', mappedParams, formValues) ||
          state.userData.subProduct.includes('trygdrive'),
        customer: {
          age,
          birthDate: getValueFromObjects('birthdate', mappedParams, formValues) || '',
          civilRegistrationNumber: getCPRMapping(mappedParams, formValues),
          rolePlayerId: getValueFromObjects('rolePlayerId', mappedParams, formValues) || '',
          occupation: getValueFromObjects('employmentInput', mappedParams, formValues) || '',
          isSelfEmployed: getValueFromObjects('seftEmployed', mappedParams, formValues) || false,
          postalAddress: getAddressMappingV2(mappedParams, formValues),
        },
        personInsurance: {
          ageGroup,
          disabilityMinPercentage: '',
        },
        sumInsured: {
          compensationDisabledSum: getValueFromObjects('compensationDisabledSum', mappedParams, formValues) || '',
          compensationDeathSum: getValueFromObjects('compensationDeathSum', mappedParams, formValues) || '',
        },
        payment: {
          paymentFrequency: '12',
        },
        coverage: [],
      };

      if (state.userData.personal) {
        return dispatch(
          this.updatePersonalAction(mappedParams, actionOnErrors, requestModel, {
            ...formValues,
          })
        ).catch(data => {
          return Promise.resolve(data);
        });
      }

      return dispatch(
        this.createPersonalAction(mappedParams, actionOnErrors, requestModel, formValues)
      ).catch(data => {
        return Promise.resolve(data);
      });
    };
  }

  prepareCreateUpdateResponse(payload, mappedParams, formValues) {
    let response = prepareCommonCreateUpdateResponse.call(this, payload, formValues);
    response = { ...response,
    };
    return response;
  }

  getPersonMapping() {
    return {
      product: {
        type: PersonalService.TYPE,
      },
    };
  }

  purchase(params, values, actionOnErrors) {
    return (dispatch, getState) => {
      const state = getState();
      const formValues = { ...values, ...state.userData };
      const mappedParams = params ? createParams(params, formValues, state) : {};
      const errors = params ? validateParams(mappedParams, params) : [];

      if (errors.length > 0) {
        return Promise.reject(createErrorBody('Missing parameters', errors));
      }

      const requestModel = {
        ppiCaseId: getValueFromObjects(
          'ppiId',
          mappedParams,
          formValues
        ),
      };

      return dispatch(super.purchaseV2(PersonalService.PERSONAL_PURCHASE,
        mappedParams, requestModel, formValues, actionOnErrors));
    };
  }
}

export const personalService = new PersonalService();